import { ReactNode, Children, isValidElement } from 'react';

interface SmallTipProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

const allowedTags = ['p', 'strong', 'i', 'u', 'a', 'ul', 'ol', 'li'];
type AllowedTagType = typeof allowedTags[number];

function isAllowedTag(child: ReactNode, allowedTags: readonly AllowedTagType[]): child is ReactNode {
  if (isValidElement(child)) {
    return allowedTags.includes(child.type as AllowedTagType);
  }
  return false;
}

export default function SmallTip({ title, className, children }: SmallTipProps) {
  const filteredChildren = Children.toArray(children).filter((child) => isAllowedTag(child, allowedTags));

  return (
    <div className={`small-tip d-flex w-100 ${className ?? ''}`}>
      <svg className="flex-shrink-0 small-tip-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.0078 17.8734V20.2148C10.0078 21.3194 10.9032 22.2148 12.0078 22.2148C13.1124 22.2148 14.0078 21.3194 14.0078 20.2148V17.8734M12.0078 2.21484V3.21484M3.00781 12.2148H2.00781M5.50781 5.71484L4.90771 5.11475M18.5078 5.71484L19.1081 5.11475M22.0078 12.2148H21.0078M18.0078 12.2148C18.0078 15.5286 15.3215 18.2148 12.0078 18.2148C8.6941 18.2148 6.00781 15.5286 6.00781 12.2148C6.00781 8.90114 8.6941 6.21484 12.0078 6.21484C15.3215 6.21484 18.0078 8.90114 18.0078 12.2148Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <div>
        <div className="small-tip-heading fw-bold">
          {title || 'Reminder:'}
        </div>
        <div className="small-tip-content">
          {filteredChildren}
        </div>
      </div>
    </div>
  )
}
